import React from 'react'
import '../../styles/App.css'

class UpDownArrow extends React.Component{
  constructor(props){
    super(props)
    this.state ={
      isDown: true,
      arrowStyle: 'upDownArrow',
      isActive: false      
    }
  }

  onClick(){
    this.setState({
      isDown: !this.state.isDown,
      arrowStyle: 'upDownArrowActive',
      isActive: true
    })
    this.props.onArrowClick(this.props.id, this.state.isDown, this.props.dataName)
  }

  defaultDownArrow(){
    this.setState({
      isDown: true,
      arrowStyle: 'upDownArrow',
      isActive: false
    })
  }

  render(){
    return this.state.isDown?
    <span 
      onClick ={this.onClick.bind(this)} 
      className = {this.state.arrowStyle}>
        &#x025BE;
    </span>
    :
    <span 
      onClick ={this.onClick.bind(this)} 
      className = {this.state.arrowStyle}>
        &#x025B4;
    </span>
  }
}
export default UpDownArrow